import { FormLabel } from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import MuiInput from '@mui/material/Input';
import Slider from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { useActividadesContext } from '../../UmmIACategories/Hook/useActividades';

const Input = styled(MuiInput)`
  width: 42px;
`;

export default function DuracionHorasSemanaUmmIApps() {
    const { promptData, setPromptData } = useActividadesContext();
    const [value, setValue] = useState(promptData.horas_semanales || 12);
    
    // Maneja cambios en el valor de las horas semanales
    const handleHorasSemanaChange = (nuevaCantidadHoras) => {
        setPromptData((prevPromptData) => ({
            ...prevPromptData,
            horas_semanales: nuevaCantidadHoras,
        }));
    };

    const handleSliderChange = (event, newValue) => {
        setValue(newValue);
        handleHorasSemanaChange(newValue);
    };

    const handleInputChange = (event) => {
        const newValue = event.target.value === '' ? 1 : Number(event.target.value);
        setValue(newValue);
        handleHorasSemanaChange(newValue);
    };

    const handleBlur = () => {
        if (value < 1) {
            setValue(1);
            handleHorasSemanaChange(1);
        } else if (value > 30) {
            setValue(30);
            handleHorasSemanaChange(30);
        }
    };

    return (
        <Box sx={{ width: '90%', m: 5 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', pb: 1 }}>
                <Typography sx={{ fontFamily: 'Inter', fontSize: '1.25rem', fontWeight: 'bold', color: '#336B87' }}>
                    Horas semanales *
                </Typography>
                <FormLabel component="p" sx={{ fontFamily: 'Inter', fontSize: '0.85rem', mt: 0.2 }}>
                    Selecciona el total de horas pedagógicas que cada semana se dedicará a la implementación
                    de esta planificación.
                </FormLabel>
            </Box>

            <Grid container spacing={2}>
                <Grid item xs>
                    <Slider
                        value={typeof value === 'number' ? value : 0}
                        onChange={handleSliderChange}
                        aria-labelledby="input-slider"
                        color="success"
                        sx={{ color: '#336B87' }}
                        valueLabelDisplay="auto"
                        defaultValue={12}
                        min={1}
                        max={30}
                    />
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography
                            variant="body2"
                            sx={{ cursor: 'pointer', fontSize: '0.6rem' }}
                        >
                            1 hr
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{ cursor: 'pointer', fontSize: '0.6rem' }}
                        >
                            30 hrs
                        </Typography>
                    </Box>
                </Grid>
                <Grid item>
                    <Input
                        value={value}
                        size="small"
                        onChange={handleInputChange}
                        onBlur={handleBlur}
                        inputProps={{
                            step: 1,
                            min: 1,
                            max: 30,
                            type: 'number',
                            'aria-labelledby': 'input-slider',
                        }}
                    />
                    <Typography sx={{ fontSize: '0.6rem' }}>Horas por semana</Typography>
                </Grid>
            </Grid>
        </Box>
    );
}
